// extracted by mini-css-extract-plugin
module.exports = {"rewriteAntdInput":"dxdpKaWt","border":"FXOzGjbQ","borderRadius":"ctnVLhVt","noBorder":"hGwzxNGZ","hoverIcon":"IGlR0hjL"};